/* eslint-disable react/prop-types, react/jsx-handler-names */

// From react-select integration example at:
// https://material-ui.com/demos/autocomplete/

import PropTypes from "prop-types";
import React from "react";

import { isEqual } from "lodash";

import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import NoSsr from "@mui/material/NoSsr";
import MuiTextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";

import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";

import Autocomplete from "@mui/material/Autocomplete";

// import InputAdornment from "@material-ui/core/InputAdornment";
// import Icon from "@material-ui/core/Icon";
import Home from "@mui/icons-material/Home";

import consultationStyles from "../styles/consultationStyles.js";

export const stateSuggestions = [
  { label: "Alabama (AL)", value: "AL" },
  { label: "Alaska (AK)", value: "AK" },
  { label: "Arizona (AZ)", value: "AZ" },
  { label: "Arkansas (AR)", value: "AR" },
  { label: "California (CA)", value: "CA" },
  { label: "Colorado (CO)", value: "CO" },
  { label: "Connecticut (CT)", value: "CT" },
  { label: "Delaware (DE)", value: "DE" },
  { label: "District Of Columbia (DC)", value: "DC" },
  { label: "Florida (FL)", value: "FL" },
  { label: "Georgia (GA)", value: "GA" },
  { label: "Guam (GU)", value: "GU" },
  { label: "Hawaii (HI)", value: "HI" },
  { label: "Idaho (ID)", value: "ID" },
  { label: "Illinois (IL)", value: "IL" },
  { label: "Indiana (IN)", value: "IN" },
  { label: "Iowa (IA)", value: "IA" },
  { label: "Kansas (KS)", value: "KS" },
  { label: "Kentucky (KY)", value: "KY" },
  { label: "Louisiana (LA)", value: "LA" },
  { label: "Maine (ME)", value: "ME" },
  { label: "Marshall Islands (MH)", value: "MH" },
  { label: "Maryland (MD)", value: "MD" },
  { label: "Massachusetts (MA)", value: "MA" },
  { label: "Michigan (MI)", value: "MI" },
  { label: "Minnesota (MN)", value: "MN" },
  { label: "Mississippi (MS)", value: "MS" },
  { label: "Missouri (MO)", value: "MO" },
  { label: "Montana (MT)", value: "MT" },
  { label: "Nebraska (NE)", value: "NE" },
  { label: "Nevada (NV)", value: "NV" },
  { label: "New Hampshire (NH)", value: "NH" },
  { label: "New Jersey (NJ)", value: "NJ" },
  { label: "New Mexico (NM)", value: "NM" },
  { label: "New York (NY)", value: "NY" },
  { label: "North Carolina (NC)", value: "NC" },
  { label: "North Dakota (ND)", value: "ND" },
  { label: "Northern Mariana Islands (MP)", value: "MP" },
  { label: "Ohio (OH)", value: "OH" },
  { label: "Oklahoma (OK)", value: "OK" },
  { label: "Oregon (OR)", value: "OR" },
  { label: "Pennsylvania (PA)", value: "PA" },
  { label: "Puerto Rico (PR)", value: "PR" },
  { label: "Rhode Island (RI)", value: "RI" },
  { label: "South Carolina (SC)", value: "SC" },
  { label: "South Dakota (SD)", value: "SD" },
  { label: "Tennessee (TN)", value: "TN" },
  { label: "Texas (TX)", value: "TX" },
  { label: "Utah (UT)", value: "UT" },
  { label: "Vermont (VT)", value: "VT" },
  { label: "Virgin Islands (VI)", value: "VI" },
  { label: "Virginia (VA)", value: "VA" },
  { label: "Washington (WA)", value: "WA" },
  { label: "West Virginia (WV)", value: "WV" },
  { label: "Wisconsin (WI)", value: "WI" },
  { label: "Wyoming (WY)", value: "WY" },
].map((suggestion) => ({
  value: suggestion.value,
  label: suggestion.label,
}));

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  // const { classes, formikProps } = props;

  return (
    <div>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <Home />
        </Grid>
        <Grid item style={{ width: "80%" }}>
          <MuiTextField
            fullWidth
            variant="filled"
            label="US State you live in..."
            InputProps={{ inputComponent }}
            id="usState"
            name="usState"
            inputProps={{
              className: props.selectProps.classes.input,
              inputRef: props.innerRef,
              children: props.children,
              ...props.innerProps,
            }}
            {...props.selectProps.textFieldProps}
          />
        </Grid>
      </Grid>
    </div>
  );
}

//   return (
//     <div>
//       <TextField
//         fullWidth
//         InputProps={{
//           inputComponent,
//           startAdornment: (
//             <InputAdornment
//               position="start"
//               className={props.selectProps.classes.inputAdornment}
//             >
//               <Home />
//             </InputAdornment>
//           ),
//           inputProps: {
//             className: props.selectProps.classes.input,
//             inputRef: props.innerRef,
//             children: props.children,
//             ...props.innerProps
//           }
//         }}
//         {...props.selectProps.textFieldProps}
//       />
//     </div>
//   );
// }

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class AutocompleteUSStates extends React.Component {
  constructor(props) {
    super(props);

    // console.log("constructor autocompleteUSState props: ", props);
    // console.log("constructor initialvalue: ", props.initialValue);

    this.state = {
      initialStateChanged: false,
      usState: props.initialValue,
      inputValue: "",
      // usState: { label: "Kansas", value: "KS" },
    };
  }

  // https://codesandbox.io/s/jRzE53pqR

  render() {
    // console.log("... rendering autocompleteUSStates");
    // console.log("autocompleteUSState state: ", this.state);
    const { classes, theme, formikProps } = this.props;

    // console.log("props: ", this.props);

    // if (!this.state.initialStateChanged && this.props.initialValue) {
    //   console.log("initialValue: ", this.props.initialValue);
    //   formikProps.setFieldValue(this.props.name, this.state.usState);
    // }

    // if (!this.state.initialStateChanged) {
    //   formikProps.setFieldValue(this.props.name, this.props.initialValue);
    // }

    // const fieldProps = formikProps.getFieldProps(this.props.name);

    const selectStyles = {
      input: (base) => ({
        ...base,
        color: theme.palette.text.primary,
        "& input": {
          font: "inherit",
        },
      }),
    };

    return (
      <React.Fragment>
        <NoSsr>
          {/* <Select
            formikProps={formikProps}
            classes={classes}
            styles={styles}
            options={stateSuggestions}
            components={components}
            onBlur={() => formikProps.setFieldTouched(this.props.name)}
            onChange={(event) => {
              formikProps.setFieldValue(this.props.name, {
                label: event.label,
                value: event.value,
              });

              this.setState({
                initialStateChanged: true,
                usState: {
                  label: event.label,
                  value: event.value,
                },
              });
            }}
            value={
              this.state.initialStateChanged
                ? this.state.usState
                : this.props.initialValue
            }
            // placeholder="US State you live in..."
          /> */}

          <Autocomplete
            // formikProps={formikProps}
            autoComplete={true}
            disableClearable
            autoSelect={true}
            options={stateSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return isEqual(option, value);
            }}
            inputValue={this.state.inputValue}
            onInputChange={(event, value, reason) => {
              // Remove non-alphabetical characters (except spaces and parentheses) from the input
              const sanitizedValue = value.replace(/[^a-zA-Z\s\(,)]/g, "");
              if (sanitizedValue !== this.state.inputValue) {
                this.setState({ inputValue: sanitizedValue });
              }
            }}
            filterOptions={(options, state) => {
              // Custom filter that uses the sanitized input value
              const inputValue = state.inputValue.toLowerCase();
              return options.filter((option) =>
                option.label.toLowerCase().includes(inputValue),
              );
            }}
            // style={{ width: 300 }}
            renderInput={(params) => {
              return (
                <Grid
                  container
                  spacing={1}
                  alignItems="flex-end"
                  justifyContent="center"
                >
                  <Grid item style={{ width: "100%" }}>
                    <label className={classes.label}>US State you are in</label>
                    <MuiTextField
                      variant="outlined"
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "dont-fill-me-pls", // disable browser autofill
                        placeholder: "Select State",
                      }}
                    />
                  </Grid>
                </Grid>
              );
            }}
            value={
              this.state.initialStateChanged
                ? this.state.usState
                : this.props.initialValue || null
            }
            onChange={(event, data) => {
              // console.log("event:", event);
              // console.log("data:", data);

              if (data) {
                // console.log("onChange: setting field value to: ", data);
                formikProps.setFieldValue(this.props.name, {
                  label: data.label,
                  value: data.value,
                });

                this.setState({
                  initialStateChanged: true,
                  usState: {
                    label: data.label,
                    value: data.value,
                  },
                  inputValue: "",
                });
              }
            }}
          />
        </NoSsr>
        <FormHelperText error style={{ marginTop: "6px", marginLeft: "32px" }}>
          {formikProps.touched[this.props.name] &&
          formikProps.errors[this.props.name] != null
            ? "Please select the State you live in"
            : ""}
        </FormHelperText>
      </React.Fragment>
    );
  }
}

AutocompleteUSStates.propTypes = {
  classes: PropTypes.object.isRequired,
  // theme: PropTypes.object.isRequired
};

// export default withStyles(styles, { withTheme: true })(AutocompleteUSStates);
export default withStyles(consultationStyles, { withTheme: true })(
  AutocompleteUSStates,
);

{
  /* <FormHelperText
error
style={{ marginTop: "6px", marginLeft: "32px" }}
>
{formikProps.form.errors[formikProps.field.name] != null
  ? "Please select the State you live in"
  : ""}
</FormHelperText> */
}
